// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4":"ScientificProgram","9":"Contact","274":"Home","450":"About","549":"Policy","756":"Events"}[chunkId] + "." + {"4":"9615a2f2","9":"8495944a","274":"ae63feab","450":"ea266405","549":"369e015b","756":"d1197f31"}[chunkId] + ".chunk.css";
};